<template>
  <li
    @click.stop="selectOptionClick"
    class="bcc-option"
    :class="{
      'selected': itemSelected,
      'is-disabled': disabled
    }"
  >
    <slot>
      <span>{{ displayLabel }}</span>
    </slot>
    <bcc-icon type="ic_MenuButton-tick" />
  </li>
</template>
<script>
import Emitter from '../../utils/emitter'
import BccIcon from '../icon'

export default {
  name: 'BccOption',
  componentName: 'BccOption',
  mixins: [Emitter],
  components: {
    BccIcon
  },
  inject: ['select'],
  props: {
    value: {
      required: true
    },
    label: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    itemSelected () {
      return this.select.value === this.value
    },
    displayLabel () {
      return this.label || this.value
    }
  },
  watch: {
    displayLabel () {
      this.dispatch('BccSelect', 'updateLabel')
    }
  },
  methods: {
    selectOptionClick () {
      if (this.disabled) return
      this.dispatch('BccSelect', 'handleOptionClick', [this, true])
    }
  },
  created () {
    this.select.options.push(this)
  }
}
</script>
